export interface InterceptRule {
  urls: string[];
  headers: string[];
  key: string;
}

export interface PageInstanceMapping {
  urlContains: string;
  mappings: Record<string, string>;
  headerKey: string;
}

export enum RuleActionType {
  MODIFY_HEADERS = 'modifyHeaders',
}

export enum HeaderOperation {
  SET = 'set',
}

export enum ResourceType {
  XMLHTTPREQUEST = 'xmlhttprequest',
  MAIN_FRAME = 'main_frame',
  SUB_FRAME = 'sub_frame',
}

export interface RequestHeader {
  header: string;
  operation: HeaderOperation;
  value: string;
}

export interface Action {
  type: RuleActionType;
  requestHeaders: RequestHeader[];
}

export interface Condition {
  urlFilter: string;
  resourceTypes: ResourceType[];
  tabIds?: number[];
}

export interface DynamicRule {
  id: number;
  sessionRule?: boolean;
  priority: number;
  action: Action;
  condition: Condition;
}

export interface DynamicRulesConfig {
  removeRuleIds: number[];
  addRules: DynamicRule[];
}
